import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=4928f59c&scoped=true&"
import script from "./awards.vue?vue&type=script&lang=js&"
export * from "./awards.vue?vue&type=script&lang=js&"
import style0 from "./awards.vue?vue&type=style&index=0&id=4928f59c&lang=scss&scoped=true&"
import style1 from "./awards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928f59c",
  null
  
)

export default component.exports